<div class="position-relative">
  <div class="modal-header">
    <h5 class="modal-title d-flex align-items-center">
      Upload File
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>

  <div class="modal-body">
    <!-- Drag and Drop Area -->
    <div
      class="upload-area"
      [class.dragging]="isDragging"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="fileInput.click()"
    >
      <div class="upload-content">
        <i class="ri-upload-cloud-2-line upload-icon"></i>
        <p class="upload-text mb-2">Click to upload or drag and drop</p>
        <p class="upload-hint">PDF ({{ maxFileSizeMB }}MB file size)</p>
      </div>
      <input
        #fileInput
        type="file"
        class="d-none"
        accept=".pdf,application/pdf"
        multiple
        (change)="onFileSelected($event)"
      />
    </div>

    <!-- File Upload Progress List -->
    <div class="file-list mt-4" *ngIf="files.length > 0">
      <div
        class="file-item"
        *ngFor="let fileStatus of files; let i = index"
        [class.error]="fileStatus.error"
      >
        <div class="d-flex align-items-center">
          <div class="file-icon me-3">
            <i class="ri-file-pdf-line"></i>
          </div>
          <div class="flex-grow-1">
            <div class="file-name">{{ fileStatus.file.name }}</div>
            <div class="file-size-progress">
              <span *ngIf="fileStatus.uploading">
                {{ formatFileSize(fileStatus.uploadedBytes) }} of {{ formatFileSize(fileStatus.totalBytes) }}
              </span>
              <span *ngIf="fileStatus.uploadedFile && !fileStatus.uploading" class="text-success">
                Uploaded successfully
              </span>
              <span *ngIf="!fileStatus.uploadedFile && !fileStatus.uploading && !fileStatus.error" class="text-muted">
                Ready to upload
              </span>
              <span *ngIf="fileStatus.error" class="text-danger">
                Upload failed
              </span>
            </div>
            <div class="file-status" *ngIf="fileStatus.uploading">
              <span>Uploading...</span>
            </div>
            <!-- Progress Bar -->
            <div class="progress mt-2" *ngIf="fileStatus.uploading">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                [style.width.%]="fileStatus.progress"
                [attr.aria-valuenow]="fileStatus.progress"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-link text-danger ms-3"
            (click)="removeFile(i)"
            title="Remove file"
          >
            <i class="ri-delete-bin-line"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer border-0 pt-0 d-flex align-items-center gap-2">
    <app-button label="Close" type="button" variant="secondary" customClass="modal-cancel-btn" (buttonClick)="onClose()"></app-button>
    <app-button type="button" variant="primary" customClass="modal-confirm-btn" [disabled]="!canCreateRequests || isUploading" (buttonClick)="onCreateRequests()">
      <span *ngIf="isUploading">Processing...</span>
      <span *ngIf="!isUploading">Create Requests</span>
    </app-button>
  </div>
</div>

